import { useState } from "react";
import cross from "../assets/images/cross-gray.svg";

export const CustomTagInput = ({ tags = [], handleAddTag, removeTag }) => {
  const [value, setValue] = useState("");

  const handleChange = (e) => setValue(e.target.value);
  // Handle the Enter key press in the input field
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && value.trim()) {
      handleAddTag(value);
      setValue(""); // Clear the input field
      e.preventDefault(); // Prevent default Enter key behavior
    }
  };

  return (
    <div className="d-flex flex-column gap-2">
      <div className="add_value_wrap-create d-flex- align-items-center">
        <div className="add_vlue_input_tage">
          <input
            type="text"
            name="title"
            value={value}
            disabled={tags.length > 2}
            placeholder="Tags of the textbook"
            className="form-control pl_0 book_detail_overview_title mb-0"
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
          <span className="add_tages">{tags.length}/3</span>
        </div>
        <button
          type="button"
          disabled={tags.length === 2}
          className="add_btn_value_create"
          onClick={() => value && handleAddTag(value)}
        >
          Add
        </button>
      </div>
      <div className="d-flex gap-2">
        {tags.map((item, index) => (
          <Tags tag={item} key={index} removeTag={removeTag} />
        ))}
      </div>
    </div>
  );
};

export const Tags = ({ tag, removeTag }) => {
  return (
    <div className="d-flex align-items-center py-2p px-12 gap-2 bg-grey-300 rounded-4">
      <span className="fs-12 fw-semibold fst-normal bg-grey-800">{tag}</span>
      <img
        className="cursor"
        src={cross}
        width={16}
        height={16}
        onClick={() => removeTag(tag)}
      />
    </div>
  );
};
